import { ThemeSelectors, TypeInsignia } from "@at/design-system-foundation";
import styled from "styled-components";

export const Heading = styled(TypeInsignia)`
  margin-bottom: ${({ theme }) => ThemeSelectors.getGroupTwoSpacing(theme)};
`;

export const TechSpecWrapper = styled.div`
  margin-bottom: ${({ theme }) =>
    `calc(${ThemeSelectors.getGroupTwoSpacing(theme)} * 4)`};
`;

export const StandardEquipmentWrapper = styled.div`
  margin-top: ${({ theme }) => ThemeSelectors.getGroupFourSpacing(theme)};
  margin-bottom: ${({ theme }) => ThemeSelectors.getGroupFourSpacing(theme)};
`;
